export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13842.0a607297.jpg";